<ng-container *ngIf="initialized">
  <p-dialog
    header="Variable auswählen"
    [(visible)]="openDialog"
    [style]="{ width: '50vw', height: '85%', background: 'white' }"
    (onHide)="handleCancel()"
  >
    <mvs-te-variables
      [variableProviderService]="variableProviderService"
      [alias]="alias"
      [attributeName]="attributeName"
      [contentProviderId]="contentProviderId"
      [isAddButtonShown]="false"
      [isTitleShown]="false"
      [treeWidth]="false"
      [selectMode]="'single'"
      [dragMode]="false"
      (onVariableSelect)="handleVariableSelect($event)"
    ></mvs-te-variables>
    
    <ng-template #footer>
      <div class="justify-content-center flex">
        <p-button
          [disabled]="!isVariableSelected"
          icon="fa-regular fa-check"
          (click)="handleConfirmVariableSelect()"
          label="Bestätigen"
          styleClass="p-button-text"
        ></p-button>

        <p-button
          icon="fa-regular fa-xmark"
          (click)="handleConfirmClose()"
          label="Schließen"
        ></p-button>
      </div>
    </ng-template>
  </p-dialog>
</ng-container>
